import { render, staticRenderFns } from "./RegisteredPage.vue?vue&type=template&id=50b40fc0&scoped=true&"
import script from "./RegisteredPage.vue?vue&type=script&lang=js&"
export * from "./RegisteredPage.vue?vue&type=script&lang=js&"
import style0 from "./RegisteredPage.vue?vue&type=style&index=0&id=50b40fc0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b40fc0",
  null
  
)

export default component.exports